module.exports = __webpack_public_path__ + "react/sources/images/poppins-v9-latin-200.woff";